import { Category, Item } from '@reliance/types/models/Commissary';
import { IPaginatedResponse } from '../../services/api_service';
import {
    CATEGORIES_LOADING,
    CATEGORIES_LOAD_FAILED,
    CATEGORIES_LOAD_SUCCESS,
    CATEGORY_ADD,
    CATEGORY_ADD_EDIT_CANCEL,
    CATEGORY_EDIT,
    CATEGORY_ITEMS_LOADING,
    CATEGORY_ITEMS_LOAD_FAILED,
    CATEGORY_ITEMS_LOAD_SUCCESS,
    CATEGORY_SAVE_FAILED,
    CATEGORY_SAVE_SUCCESS,
    CATEGORY_SAVING,
    CATEGORY_VIEW,
    ITEM_ADD,
    ITEM_ADD_EDIT_CANCEL,
    ITEM_EDIT,
    ITEM_SAVE_FAILED,
    ITEM_SAVE_SUCCESS,
    ITEM_SAVING
} from '../actions/commissary';

export interface ICommissaryManageState {
  loadingCategories: boolean;
  categories?: Category[];
  error?: any;

  viewCategory: Category;
  viewCategoryItems: IPaginatedResponse<Item>;
  viewCategoryItemsLoading: boolean;
  viewCategoryItemsLoadError: Error;

  addingCategory: boolean;
  editingCategory: Category;
  savingCategory: boolean;
  savingCategoryError: Error;

  addingItem: boolean;
  editingItem: Item;
  savingItem: boolean;
  savingItemError: Error;
}

const initialState: ICommissaryManageState = {
  loadingCategories: false,
  categories: null,
  error: null,

  viewCategory: null,
  viewCategoryItems: null,
  viewCategoryItemsLoading: false,
  viewCategoryItemsLoadError: null,

  addingCategory: false,
  editingCategory: null,
  savingCategory: false,
  savingCategoryError: null,

  addingItem: false,
  editingItem: null,
  savingItem: false,
  savingItemError: null
};

export default function (
  state: ICommissaryManageState = initialState,
  action
): ICommissaryManageState {
  switch (action.type) {
    case CATEGORIES_LOADING:
      return {
        ...state,
        loadingCategories: true,
        categories: null,
        error: null
      };

    case CATEGORIES_LOAD_SUCCESS:
      return {
        ...state,
        loadingCategories: false,
        categories: action.categories.data,
        error: null
      };

    case CATEGORIES_LOAD_FAILED:
      return {
        ...state,
        loadingCategories: false,
        categories: null,
        error: action.error
      };

    case CATEGORY_VIEW:
      return {
        ...state,
        viewCategory: action.category
      };

    case CATEGORY_ITEMS_LOADING:
      return {
        ...state,
        viewCategoryItems: null,
        viewCategoryItemsLoading: true,
        viewCategoryItemsLoadError: null
      };

    case CATEGORY_ITEMS_LOAD_SUCCESS:
      return {
        ...state,
        viewCategoryItems: action.items,
        viewCategoryItemsLoading: false,
        viewCategoryItemsLoadError: null
      };

    case CATEGORY_ITEMS_LOAD_FAILED:
      return {
        ...state,
        viewCategoryItems: null,
        viewCategoryItemsLoading: false,
        viewCategoryItemsLoadError: action.error
      };

    case CATEGORY_ADD:
      return {
        ...state,
        addingCategory: true
      };

    case CATEGORY_ADD_EDIT_CANCEL:
      return {
        ...state,
        addingCategory: false,
        editingCategory: null
      };

    case CATEGORY_EDIT:
      return {
        ...state,
        editingCategory: action.category
      };

    case CATEGORY_SAVING:
      return {
        ...state,
        savingCategory: true,
        savingCategoryError: null
      };

    case CATEGORY_SAVE_SUCCESS:
      return {
        ...state,
        addingCategory: false,
        editingCategory: null,
        savingCategory: false,
        savingCategoryError: null,
        viewCategory: action.category
      };

    case CATEGORY_SAVE_FAILED:
      return {
        ...state,
        savingCategory: false,
        savingCategoryError: action.error
      };

    case ITEM_ADD:
      return {
        ...state,
        addingItem: true
      };

    case ITEM_ADD_EDIT_CANCEL:
      return {
        ...state,
        addingItem: false,
        editingItem: null
      };

    case ITEM_EDIT:
      return {
        ...state,
        editingItem: action.item
      };

    case ITEM_SAVING:
      return {
        ...state,
        savingItem: true,
        savingItemError: null
      };

    case ITEM_SAVE_SUCCESS:
      let updatedItems = state.viewCategoryItems;
      if (action.item && updatedItems) {
        updatedItems.data = state.viewCategoryItems.data.map((i) => {
          if (i.id == action.item.id) {
            return action.item;
          }
          return i;
        });
      }

      return {
        ...state,
        addingItem: false,
        savingItem: false,
        savingItemError: null,
        editingItem: null,
        viewCategoryItems: updatedItems
      };

    case ITEM_SAVE_FAILED:
      return {
        ...state,
        savingItem: false,
        savingItemError: action.error
      };
  }

  return state;
}
